import PropTypes from 'prop-types';
import { DataGrid } from '@celltrak/ui-components';

import { resolutionListHeaders } from '../../constants';
import { getSelectionToClipboard } from '../../../Common/utils';

import useResolutionList from './hooks';
import styles from './ResolutionList.module.scss';

function ResolutionList({ resolutionReports, loading }) {
  const { handleColumnClick, sortByColumn, sortDirection } = useResolutionList();

  return (
    <div className={styles.gridContainer} onMouseUp={getSelectionToClipboard} role="none">
      <DataGrid
        rows={resolutionReports}
        headers={resolutionListHeaders}
        fullWidth
        loading={loading}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
      />
    </div>
  );
}

ResolutionList.propTypes = {
  resolutionReports: PropTypes.arrayOf(
    PropTypes.shape({
      resolutionCode: PropTypes.string,
      description: PropTypes.string,
      alertType: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
};

ResolutionList.defaultProps = {
  resolutionReports: [],
  loading: false,
};

export default ResolutionList;
